export default "__VITE_ASSET__DDyGO1cx__"